import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-modern">
      <Container>
        <Row>
          <Col lg={4} className="mb-4 mb-lg-0">
            <h4 className="footer-brand-modern mb-3">DHS CRM</h4>
            <p className="footer-description-modern">
              All-in-one CRM for home service businesses.
            </p>
          </Col>

          <Col lg={2} md={6} className="mb-4 mb-lg-0">
            <h6 className="footer-heading-modern mb-3">Product</h6>
            <ul className="footer-links-modern">
              <li><a href="#features">Features</a></li>
              <li><a href="#pricing">Pricing</a></li>
            </ul>
          </Col>

          <Col lg={2} md={6} className="mb-4 mb-lg-0">
            <h6 className="footer-heading-modern mb-3">Company</h6>
            <ul className="footer-links-modern">
              <li><a href="/about">About</a></li>
              <li><a href="/blog">Blog</a></li>
            </ul>
          </Col>

          <Col lg={2} md={6} className="mb-4 mb-lg-0">
            <h6 className="footer-heading-modern mb-3">Legal</h6>
            <ul className="footer-links-modern">
              <li><a href="/privacy">Privacy</a></li>
              <li><a href="/terms">Terms</a></li>
            </ul>
          </Col>
        </Row>

        <hr className="footer-divider-modern" />

        <Row>
          <Col className="text-center">
            <p className="footer-copyright-modern">
              &copy; {currentYear} DHS CRM. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;